<script setup lang="ts" name="Login">
import { useToggle } from '@vueuse/core'
import { provide, ref } from 'vue'
import SMS from './SMS.vue'
import Account from './Account.vue'

const loginType = ref<'DEFAULT' | 'PHONE'>('DEFAULT')
const toggle = useToggle(loginType, {
  truthyValue: 'DEFAULT',
  falsyValue: 'PHONE',
})

provide('toggle', toggle)

const ComponentsMap = {
  DEFAULT: Account,
  PHONE: SMS,
}
</script>

<template>
  <section
    class="bg-[rgba(0,0,0,0.5)] text-[#fff] p-6 rounded-2 overflow-hidden w-[360px] h-[310px] backdrop-blur-lg"
    style="--el-color-danger: #FA4563; --el-component-size-large: 36px; --el-button-size: 36px"
  >
    <component :is="ComponentsMap[loginType]" />
  </section>
</template>
